import mixpanel from 'mixpanel-browser';
import React from 'react';
import { Provider } from './mixpanel-context';

const defaults = {
	track_pageview: false, // Rarely makes sense to track page views in React apps
};

const MixpanelProvider = ({ children, config, name, token }) => {
	return (
		<Provider value={mixpanel}>
			{children}
		</Provider>
	);

};

export default MixpanelProvider;